import React, { Suspense } from 'react';

// Routes
import { Route as Origin } from 'design/router';

// Components
import { Spinner } from 'design/components';

// Views
import { Daylight } from './daylight';
import { FactoryArm } from './factory-arm';
import { ImageAgent } from './image-agent';
import { MusicVisualiser } from './music-visualiser';
import { TreeOfLife } from './tree-of-life';

// Constants
import { PATH } from './constants';

const Contents = React.lazy(async () => {
  const { Experiments } = await import('./contents');

  return { default: Experiments };
});
const Home = React.lazy(async () => {
  const { Home } = await import('./home');

  return { default: Home };
});

const Lazy: React.FunctionComponent = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <Contents />
    </Suspense>
  );
};

const Experiments = (
  <Origin path={PATH} element={<Lazy />}>
    <Origin
      index
      element={
        <Suspense fallback={<Spinner />}>
          <Home />
        </Suspense>
      }
    />
    {TreeOfLife}
    {MusicVisualiser}
    {ImageAgent}
    {FactoryArm}
    {Daylight}
  </Origin>
);

export { PATH, Experiments };
